import { useEffect, useState } from 'react'
import ProgressionService from '../../../services/api/ProgressionService'

const INITIAL = {
  evolution: { grade: [], satisfaction: [] },
  sections: {
    rows: [],
    pagy: { page: 1, pages: 0, count: 0 }
  }
}

const fetchEvolution = (collectId, draftId, baseParams) => {
  const measureFor = name => ProgressionService.fetchMeasure(collectId, draftId, { name, ...baseParams })
  return Promise.all([measureFor('grade'), measureFor('satisfaction')])
}

const fetchSections = (collectId, draftId, params) =>
  ProgressionService.fetchList(collectId, draftId, { name: 'section_summaries', ...params })

// Split into two effects so paginating sections does not refetch the
// Summary cards and the evolution chart.
const useStatistics = ({ collectId, draftId, granularity, dateRange, page, perPage, resourceIds }) => {
  const [data, setData] = useState(INITIAL)
  const [overviewLoading, setOverviewLoading] = useState(true)
  const [sectionsLoading, setSectionsLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    let cancelled = false
    setOverviewLoading(true)
    setError(null)
    const baseParams = {
      startDate: dateRange?.startDate,
      endDate: dateRange?.endDate,
      granularity,
      resourceIds
    }

    fetchEvolution(collectId, draftId, baseParams)
      .then(evolution => {
        if (cancelled)
          return
        setData(prev => ({
          ...prev,
          evolution: { grade: evolution[0], satisfaction: evolution[1] }
        }))
      })
      .catch(err => { if (!cancelled)
        setError(err) })
      .finally(() => { if (!cancelled)
        setOverviewLoading(false) })

    return () => { cancelled = true }
  }, [collectId, draftId, granularity, dateRange?.startDate, dateRange?.endDate, resourceIds])

  useEffect(() => {
    let cancelled = false
    setSectionsLoading(true)
    const sectionsParams = {
      startDate: dateRange?.startDate,
      endDate: dateRange?.endDate,
      page,
      perPage,
      resourceIds
    }

    fetchSections(collectId, draftId, sectionsParams)
      .then(sections => {
        if (cancelled)
          return
        setData(prev => ({
          ...prev,
          sections: {
            rows: sections?.rows || [],
            pagy: sections?.pagy || INITIAL.sections.pagy
          }
        }))
      })
      .catch(err => { if (!cancelled)
        setError(err) })
      .finally(() => { if (!cancelled)
        setSectionsLoading(false) })

    return () => { cancelled = true }
  }, [collectId, draftId, dateRange?.startDate, dateRange?.endDate, page, perPage, resourceIds])

  return { data, overviewLoading, sectionsLoading, error }
}

export default useStatistics
